import React from 'react';
import { CSSProperties } from 'react';

export const SliderArrow = (props: any | { arrowDirection: string }) => {
    const { className, style, onClick, arrowDirection } = props;

    const sliderArrowContainerStyle: CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '35px',
        height: '35px',
        borderRadius: '35px',
        border: '2px solid black',
        background: 'none',
        padding: 0,
        cursor: 'pointer',
    };

    let sliderArrowStyle: CSSProperties = {
        width: 0,
        height: 0,
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent',
    };

    if (arrowDirection === 'left') {
        sliderArrowStyle['borderRight'] = '10px solid black';
        sliderArrowStyle['marginRight'] = '3px';
    } else if (arrowDirection === 'right') {
        sliderArrowStyle['borderLeft'] = '10px solid black';
        sliderArrowStyle['marginLeft'] = '3px';
    }

    const ariaLabel = arrowDirection === 'left' ? 'Previous slide' : 'Next slide';

    return (
        <button
            type="button"
            className={className}
            style={{ ...style, ...sliderArrowContainerStyle }}
            onClick={onClick}
            aria-label={ariaLabel}
        >
            <span style={{ ...sliderArrowStyle }} aria-hidden="true" />
        </button>
    );
};
